import { Api } from 'utils';

class DoctorService {

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/doctor',params),
		download: async (params?: any) => Api.createResponse('admin/doctor/download',params),
		create: async (params?: any) => Api.createResponse('admin/doctor/create',params),
		update: async (params?: any) => Api.createResponse('admin/doctor/update',params),
		delete: async (params?: any) => Api.createResponse('admin/doctor/delete',params),
		suspend: async (params?: any) => Api.createResponse('admin/doctor/suspend',params),
		getRates: async (params?: any) => Api.createResponse('admin/doctor/rates',params),
		deleteRate: async (params?: any) => Api.createResponse('admin/doctor/delete-rate',params),
		updateVerification: async (params?: any) => Api.createResponse('admin/doctor/update-verification',params)
	}

}

export default DoctorService;